const data = {
  topSection: {
    headingText: "Revitalize your home's exterior ",
    highlightedText: "designs that honor",
    subText: "Discover unparalleled creativity and reliable service with NatureCraft",
    headingText2: "your vision and budget",
    video : "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fvideo.mp4?alt=media&token=16e3d070-d08e-478d-950f-99066af00929"
  },

  features: [
    {
      title: 'Façade design and renovation',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fkey-features%2F1.png?alt=media&token=34a8ff33-a3f8-4d13-b9b4-ccc1ff655e73"
    },
    {
      title: 'Energy-efficient solutions',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fkey-features%2F2.png?alt=media&token=f7e5cca6-7c19-4f13-9359-3c2c74a1aaf9"
    },
    {
      title: 'Structural enhancements',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fkey-features%2F3.png?alt=media&token=0914a2f3-2ace-49e0-80df-74c584a07897"
    },
    {
      title: 'Aesthetic improvement plans',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fkey-features%2F4.png?alt=media&token=c7f1a62e-922f-4b79-866a-f66d6aecb2d8"
    },
  ],

  numbers: [
    { number: 50, label: 'Interior Experts', symbol: '+', duration: 2500 },
    { number: 60, label: 'Location Served', symbol: '+', duration: 2500 },
    { number: 1000, label: 'Happy Clients', symbol: '+', duration: 2500 },
  ],

  stepsData: [
    {
      title: 'Client Meeting',
      description: 'Understand exterior design requirements.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fho-it-works%2F1.png?alt=media&token=1feb831d-30b2-47d9-8240-ec888029df8c"
    },
    {
      title: 'Site Evaluation',
      description: 'Examine site for exterior possibilities.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fho-it-works%2F2.png?alt=media&token=ad49a099-2707-40d4-9591-250185b76235"
    },
    {
      title: 'Design Proposal',
      description: 'Present exterior design concepts.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fho-it-works%2F3.png?alt=media&token=2d47e6a9-d951-48df-843b-f81dadaab892"
    },
    {
      title: 'Material Selection',
      description: 'Choose appropriate materials and finishes.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fho-it-works%2F4.png?alt=media&token=7add44bc-9e7b-4e61-947d-c0c26571a99e"
    },
    {
      title: 'Execution',
      description: 'Implement exterior design plan.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fho-it-works%2F5.png?alt=media&token=3e5ed494-d43d-4af5-b3d9-9ef8e196b195"
    },
    {
      title: 'Final Walkthrough',
      description: 'Review completed exterior work with client.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FExterior%2Fho-it-works%2F6.png?alt=media&token=6ceb2600-2a1a-480d-90bc-e1f916c516c3"
    },
  ],

  faqs: [
    {
      question: 'What does exterior design include?',
      answer:
        'Exterior design involves planning and styling the outer appearance of a building, including facades, color schemes, landscaping, outdoor lighting, and material selection.',
    },
    {
      question: 'Can you help with both residential and commercial exterior designs?',
      answer:
        'Yes, we offer services for both residential and commercial properties, tailoring designs to meet your style, needs, and budget.',
    },
    {
      question: 'How do you approach the design of a building’s exterior?',
      answer:
        'We begin with a consultation to understand your preferences and functional needs, then incorporate elements like architecture, sustainability, and landscaping for a cohesive design.',
    },
    {
      question: 'Can you incorporate eco-friendly elements into exterior designs?',
      answer:
        'Yes, we can include eco-friendly materials, energy-efficient lighting, sustainable building materials, and green landscaping solutions in your design.',
    },
    {
      question: 'How long does the exterior design process take?',
      answer:
        'The timeline varies by project scope. After a consultation, we provide a timeline outlining the stages from design to execution, which could range from weeks to months.',
    },
    {
      question: 'Do you offer 3D renderings for exterior designs?',
      answer:
        'Yes, we provide 3D renderings to help you visualize the design before construction, allowing for adjustments to ensure it meets your expectations.',
    },
    {
      question: 'What factors should I consider when choosing an exterior design?',
      answer:
        'Consider factors like architectural style, climate, maintenance, energy efficiency, and personal preferences. We’ll guide you through these considerations.',
    },
    {
      question: 'How do I get started with your exterior design services?',
      answer:
        'Contact us for a consultation where we’ll discuss your vision, assess your property, and provide design ideas that align with your goals.',
    },
  ],
  reviews: [
    {
      review: "Outstanding design. They captured our vision with precision and efficiency. Highly satisfied!",
      name: "Mitali Sinha",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fmitali-sinha.jpeg?alt=media&token=9c952e12-04e5-454c-a2d7-3f8796706891",
      rating: 5
    },
    {
      review: "Transformed our space beautifully. A seamless process from start to finish. Highly recommended.",
      name: "P. Gowda",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fp-gowda.jpeg?alt=media&token=cd8de94e-73a2-4a14-92c7-7b1e3ae79d48",
      rating: 4
    },
    {
      review: "They listened, they delivered. Impressed by their service.",
      name: "Nitin Prajapat",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fnitin-prajapat.jpeg?alt=media&token=f783369b-6c53-4c80-82eb-8a86e89debef",
      rating: 4
    },
    {
      review: "Fantastic architecture design & affordable.",
      name: "Snehal Raj",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fsnehal-raj.jpeg?alt=media&token=8937fcad-9cff-4196-9bde-9b114eea6990",
      rating: 5
    },
  ]
};

export default data;
